import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { fetchApi } from '../../../../lib/fetchApi';
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { RootState } from "../../../../redux/store";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { SelectedFilter } from "../../../../components/Filters/types";
import { RoleFormDto, RoleListItemDto } from "../types";
import i18n from "../../../../i18n";

const BASE_URL = "/roles";

export const getRoles = async (body: PaginationFilterDto): Promise<Pagination<RoleListItemDto>> => {
    const response = await fetchApi.post(`${BASE_URL}/`, body) as Pagination<RoleListItemDto>;
    return response;
};

type QueryFnType = typeof getRoles;

type UseSearchRolesOptions = {
    config?: QueryConfig<QueryFnType>;
    search?: string;
    filters?: SelectedFilter[];
};

export const useRoles = ({ config, search = "", filters = [] }: UseSearchRolesOptions = {}) => {

    const historical = useSelector((state: RootState) => state.historical.roles);
    const onlyActive = useSelector((state: RootState) => state.filters.roles.filterByOnlyActiveRecords);

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["roles", historical.currentPage, historical.itemsPerPage, search, JSON.stringify(filters), onlyActive, i18n.language],
        queryFn: () =>
            getRoles({
                pageNumber: historical.currentPage,
                pageSize: historical.itemsPerPage,
                search,
                filterByOnlyActiveRecords: onlyActive,
                filters,
                selectedOrganizationalStructureIds: []
            }),
    });
};

export const getRoleById = async (roleId: number): Promise<RoleFormDto> => {
    const response = await fetchApi.get(`${BASE_URL}/${roleId}`) as RoleFormDto;
    return response
};

export const createRole = async (body: RoleFormDto): Promise<RoleFormDto> => {
    const response = await fetchApi.post(`${BASE_URL}/create`, body) as RoleFormDto;
    return response;
}

export const updateRole = async (roleId: number, body: RoleFormDto): Promise<RoleFormDto> => {
    const response = await fetchApi.put(`${BASE_URL}/update/${roleId}`, body) as RoleFormDto;
    return response;
}
export const deleteLogicRole = async (roleId: number): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/delete/${roleId}`);
};